/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import playImg from '../../assets/icons/play.svg';
import pauseImg from '../../assets/icons/pause.svg';
import repeatBtnImg from '../../assets/icons/repeat.svg';
import styles from './Main.module.css';

// components
// import SimpleBtn from '../buttons/SimpleBtn';
import Select from '../buttons/Select';
import ImgBtn from '../buttons/ImgBtn';
import Input from '../buttons/NumberInput';
import Graphics from '../graphics/Graphics';

// code
import data, { uiData } from '../../logic/data';
import { restart, play } from '../../logic/process';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

class Main extends Component {
  state = {
    exampleIdx: data.exampleIdx,
    svgContent: [],
    playState: 'pause',
    pLayClickDisable: false,
    coe: data.coe,
  };

  // after component is rendered
  componentDidMount = () => {
    restart.bind(this)(false);
  };

  getState = () => this.state;

  updateSvgContent = content => this.setState({ svgContent: content });

  // process = {
  //   restart: restart.bind(this),
  //   play: play.bind(this),
  // };

  // change pay/pause state
  // must be arrow because of this
  changePlayState = val => this.setState({ playState: val });

  // play/pause was clicked
  onPlayClick = () => {
    // this.setState(state => ({
    //   playState: state.playState === 'pause' ? 'play' : 'pause',
    // }));
    setTimeout(play.bind(this), 0);
  };

  // repeat was clicked
  onRepeatClick = () => {
    data.state = 'new';
    this.changePlayState('pause');
    setTimeout(restart.bind(this), 0);
  };

  // disable/enable play click
  setPlayClickDisable = val => this.setState({ playClickDisable: val });

  // text button
  // onBtnClick = (val, idx) => {
  //   this.setState({
  //     ...
  //   });
  // };

  // change playing example
  onExampleChange = val => {
    // console.log('[EXAMPLE]', val);
    this.props.onExampleChange(val);

    // if (val !== data.examples.length - 1) {
    //   data.autoPlay = false;
    // } else {
    //   data.autoPlay = true;
    //   val = 0;
    // }
    this.setState({
      exampleIdx: val,
    });
    setTimeout(restart.bind(this), 0);
  };

  // Because this.props and this.state may be updated asynchronously,
  // you should not rely on their values for calculating the next state.
  onCoeChange = (idx, val) => {
    // console.log('COE', idx, val);
    this.setState(state => {
      const coe = state.coe;

      coe[1][idx] = +val / 100; // changed value
      coe[1][2] = 1 - coe[1][0] - coe[1][1];
      // console.log(coe);
      return { coe }; // { coe: coe }
    });
  };

  // HTML code
  render() {
    const playBtnImg = this.state.playState === 'play' ? pauseImg : playImg;
    return (
      <main>
        <Graphics content={this.state.svgContent} viewBox={uiData.svgViewBox} />
        {/* inputs */}
        <div className={styles.inputs}>
          <ImgBtn
            src={playBtnImg}
            onClick={this.onPlayClick}
            disabled={this.state.playClickDisable}
            // dataToolTip="play/pause"
          />
          <ImgBtn
            src={repeatBtnImg}
            onClick={this.onRepeatClick}
            // dataToolTip="repeat"
          />

          {/* {uiData.buttons.map((btn, idx) => (
            <SimpleBtn key={idx} obj={btn} active={idx === 0} action={this.onBtnClick.bind(this, idx)}/>
          ))} */}
          <div className={styles.coe}>
            {uiData.inputBoxes.map((inp, idx) => (
              <Input
                key={idx}
                obj={inp}
                onChange={val => this.onCoeChange(idx, val)}
                // dataToolTip={`W${idx+1}`}
              />
            ))}
          </div>

          <Select
            options={uiData.selectOptions}
            selectedIdx={this.getState().exampleIdx}
            onSelectChange={this.onExampleChange}
          />
        </div>
      </main>
    );
  }
}

export default Main;
